module.exports = __webpack_public_path__ + "Rishav-719028c2.webp";